import { c as _c } from "react/compiler-runtime";
import { SanitizedHtmlTag } from "@components/common/sanitized-html-tag";
import { getErrorDisplayMarkup, isErrorFromBackend } from "@context-providers/error-boundary/error-boundary-utils";
import { NO_TRANSLATE_CLASS } from "@flat-ui";
/**
 * Renders the human-readable detail of an error.
 * Backend errors can embed user data (names, emails, etc.), so they are excluded
 * from LocalizeJS translation. Dashboard-thrown errors are static, translatable strings.
 */
export function ErrorDetailMessage(t0) {
  const $ = _c(6);
  const {
    error
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = getErrorDisplayMarkup(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const markup = t1;
  if (isErrorFromBackend(error)) {
    let t2;
    if ($[2] !== markup) {
      t2 = <span className={NO_TRANSLATE_CLASS}><SanitizedHtmlTag markup={markup} /></span>;
      $[2] = markup;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== markup) {
    t2 = <SanitizedHtmlTag markup={markup} />;
    $[4] = markup;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}